interface Props {
  onPlayNow: () => void;
  onLogin: () => void;
}

export function LandingPage({ onPlayNow, onLogin }: Props) {
  return (
    <div className="landing">
      {/* Hero */}
      <section className="landing-hero">
        <h1 className="landing-logo">STARBRIDGE</h1>
        <p className="landing-tagline">
          Command your starship. Shape the galaxy. Every encounter is unique.
        </p>
        <div className="landing-ctas">
          <button className="landing-cta landing-cta--primary" onClick={onPlayNow}>
            PLAY NOW
          </button>
          <button className="landing-cta landing-cta--secondary" onClick={onLogin}>
            LOG IN
          </button>
        </div>
        <div className="landing-scroll-hint">SCROLL TO EXPLORE</div>
      </section>

      {/* Features */}
      <section className="landing-features">
        <div className="landing-section-label">FEATURES</div>
        <h2 className="landing-section-title">A new kind of space RPG</h2>
        <div className="landing-feature-grid">
          <div className="landing-feature-card">
            <span className="landing-feature-icon" aria-hidden>&#9784;</span>
            <div className="landing-feature-name">BRIDGE COMMAND</div>
            <div className="landing-feature-desc">
              Issue orders to your crew in natural language. Manage shields, weapons,
              sensors, and communications from your captain's chair.
            </div>
          </div>
          <div className="landing-feature-card">
            <span className="landing-feature-icon" aria-hidden>&#10022;</span>
            <div className="landing-feature-name">GALAXY EXPLORATION</div>
            <div className="landing-feature-desc">
              Navigate procedurally generated star systems. Patrol contested borders,
              investigate anomalies, and broker peace between factions.
            </div>
          </div>
          <div className="landing-feature-card">
            <span className="landing-feature-icon" aria-hidden>&#9883;</span>
            <div className="landing-feature-name">AI GAME MASTER</div>
            <div className="landing-feature-desc">
              Every encounter is driven by an AI game master that reacts to your decisions.
              No two missions play out the same way.
            </div>
          </div>
        </div>
      </section>

      {/* How it works */}
      <section className="landing-steps">
        <div className="landing-section-label">GET STARTED</div>
        <h2 className="landing-section-title">Three steps to the bridge</h2>
        <div className="landing-steps-grid">
          <div className="landing-step">
            <div className="landing-step-num">1</div>
            <div className="landing-step-title">CREATE ACCOUNT</div>
            <div className="landing-step-desc">
              Sign up in seconds with email or Google
            </div>
          </div>
          <div className="landing-step">
            <div className="landing-step-num">2</div>
            <div className="landing-step-title">CHOOSE A MISSION</div>
            <div className="landing-step-desc">
              Select a star system and pick your assignment from the galaxy map
            </div>
          </div>
          <div className="landing-step">
            <div className="landing-step-num">3</div>
            <div className="landing-step-title">TAKE COMMAND</div>
            <div className="landing-step-desc">
              Step onto the bridge and lead your crew through the encounter
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="landing-footer">
        <div className="landing-footer-text">
          STARBRIDGE — BRIDGE COMMAND RPG
        </div>
      </footer>
    </div>
  );
}
